var scope_0 = require('/home/paul/dev/paulgray.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/home/paul/dev/paulgray.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c37d9835f71cf2344707a7ca54a99b7.js').default;
var scope_2 = require('/home/paul/dev/paulgray.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1b87493e9c330ee4319e1ec41c3f82a.js').default;
var scope_3 = require('/home/paul/dev/paulgray.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efa4640fbda3858544040efdebb2ffe7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    